import { useState } from 'react';
import { TfiBackLeft } from "react-icons/tfi";
import { useNavigate } from 'react-router';
import clubImgs from '../assets/images/club.png';
import playerImg from '../assets/images/football-player.png';
import { useDispatch } from 'react-redux';
import { rootAction } from '../redux/reducer/rootReducer';

const ChooseAccountType = () => {
    const [accountType, setAccountType] = useState({ club: false, user: false });
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const redirectSignupPage = () => {
        if (accountType.club == false && accountType.user == false) {
            dispatch(rootAction.setWarningMessage({ type: 'warning',id:Date.now() ,content: "Please choose from the available account types." }));
            return;
        }
        if (accountType.club) {
            navigate('/register-club')
        }
        if (accountType.user) {
            navigate('/register-user')
        }
    }
    return (
        <div className='choose_account_type_container'>
            <div className='before_create_account_con'>
                <div className="register_email_form_back_icons">
                    <TfiBackLeft onClick={() => navigate('/login')} className='register_email_icon' />
                </div>
                <h1>New Account</h1>
                <h2>Choose Your Account Type</h2>
                <div className="before_create_account_radio_con">
                    <AccountTypeItem
                        title="Club"
                        id="club"
                        img={clubImgs}
                        isActive={accountType.club}
                        onClick={() => setAccountType({ club: true })}
                    />
                    <AccountTypeItem
                        title="Player"
                        id="player"
                        img={playerImg}
                        isActive={accountType.user}
                        onClick={() => setAccountType({ user: true })}
                    />
                    
                </div>
                
                <button onClick={redirectSignupPage}>Register</button>
            </div>
        </div>
    )
}

export default ChooseAccountType;


export const AccountTypeItem = ({ title, id, img, isActive, onClick }) => {
    return (
        <div onClick={onClick} className={isActive ? "before_create_account_radio active" : "before_create_account_radio"} >
            <input type="radio" name="accountType" checked={isActive} id={id} readOnly />
            <div className="before_create_account_radio_icons">
                <img src={img} alt="" />
                <label htmlFor={id}>{title}</label>
            </div>
        </div>
    )
}